import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import Camera from "react-html5-camera-photo";

const TakeCameraImageDialog = (props) => {
  const { visible, onHide, loading, title, onConfirm } = props;
  const [width, setWidth] = useState(200);
  const [height, setHeight] = useState(200);

  useEffect(() => {
    if (window && window.innerWidth) {
      const _width = window.innerWidth - 12 * 2 - 10;
      setWidth(_width);

      const _height = Math.floor((4 / 5) * _width);
      setHeight(_height);
    }
  }, [window]);

  function handleTakePhoto(dataUri) {
    if (dataUri) {
      if (onConfirm) {
        onConfirm(dataUri);
      }
    }
  }

  return (
    <Dialog
      headerClassName="pt-1 pb-0"
      contentClassName="pb-3 pt-1 px-3"
      visible={visible}
      // breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      modal
      // className={`p-fluid !w-[90vw] max-w-[60rem]`}
      onHide={onHide}
      dismissableMask={true}
      closable={false}
    >
      <div className="row-center-start w-100 relative h-100 gap-3 pt-1">
        <Camera
          idealFacingMode={FACING_MODES.ENVIRONMENT}
          imageType={IMAGE_TYPES.JPG}
          idealResolution={{ width: width, height: height }}
          imageCompression={0.85}
          onTakePhoto={(dataUri) => {
            handleTakePhoto(dataUri);
          }}
        />
      </div>
    </Dialog>
  );
};

export default TakeCameraImageDialog;
